
import { Card, Col, Form, Row, Space, Input, Select } from 'antd'
import { ButtonBack, ButtonSubmit, ButtonReview } from 'components/Common/Buttons';
import useTopbarTitleHooks from 'hooks/useTopbarTitleHooks';
import { useAtom } from 'jotai';
import React, { useEffect, useRef, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { APP_ROUTE_PREFIX, RouteConstant } from 'routes/routesConstant';
import useDeptRepo from "../../services/repo/useDepartmentRepo";
import useOrgRepo from "../../services/repo/useOrgRepo";
import useDivRepo from "../../services/repo/useDivisionRepo";
import usePosRepo from "../../services/repo/usePositionRepo";
import useWBSRepo from "../../services/repo/useWBSRepo";
import { INIT_WBS, wbsAtom } from 'store/WBS/wbs';
import { PRIVILEGE_ID } from 'utils/AccessPermissionConfig';
import Constant from 'utils/Constants';
import CustomAlert from 'utils/CustomAlert';
import { formatterAmountFiveDigit, setFieldValues } from 'utils/Helper';
import { dismissToast, errorToast, loadingToastId, successToast } from 'utils/Toast';
import { CustomFormItemText, CustomFormItemInteger, CustomFormItemSelectDropdown, CustomFormItemTextArea, CustomFormItemSwitch } from 'components/Common/CustomFormItem';
import SectionWbsTaskReview from './Section/SectionWbsTaskReview';



export default function ManageTaskReview() {
    const { taskId } = useParams();
    const isEditMode = Boolean(taskId);

    useTopbarTitleHooks(`${isEditMode ? "Task Review  Form" : "Task Review  Form"} Work Breakdown Structure (WBS)`);
    const { isLoading: isLoadingGetById, getDepartmentById } = useDeptRepo(false);
    const { isLoading: isLoadingOrgList, getOrgList } = useOrgRepo(false)
    const { isLoading: isLoadingDivList, getDivisionList } = useDivRepo(false)
    const { isLoading: isLoadingDeptList, getDepartmentList } = useDeptRepo(false)
    const { isLoading: isLoadingPosList, getPositionList } = usePosRepo(false)
    const { isLoading: isLoadingWbs, saveReviewDraft, submitReviewDraft, getTaskReviewById } = useWBSRepo(false);

    const [wbsTaskList, setWbsTaskList] = useState([]);
    const [dataField, setDataField] = useAtom(wbsAtom);
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const isLoadingPrivilege = useRef(true);


    const fetchCheckPrivilege = async () => {

        loadingToastId(Constant.message.loading, PRIVILEGE_ID.AddEditWbs)
        dismissToast(PRIVILEGE_ID.AddEditWbs)
        isLoadingPrivilege.current = false
    }

    const getLabelValueObject = (options, value) =>
        Array.isArray(options)
            ? options.find(opt => opt.value === value) || { value, label: value || "-" }
            : { value, label: value || "-" };

    const fetchGetWbsById = async (id) => {

        const response = await getTaskReviewById({ taskId: id });

        if (response?.detail === 'OK' && response?.status === 200) {
            const data = response?.data;

            // ✅ Panggil fetch dropdown CHAINING secara berurutan, pastikan dropdown options sudah terisi
            // await fetchDataDivision(data.orgId);
            // await fetchDataDepartment(data.divId);
            // await fetchDataPosition(data.deptId);
            const orgOptions = await fetchDataOrg();                      // ✅ make sure return [...{label,value}]
            const divOptions = await fetchDataDivision(data.orgId);
            const deptOptions = await fetchDataDepartment(data.divId);
            const posOptions = await fetchDataPosition(data.deptId);

            // ✅ Baru set form values
            // form.setFieldsValue({
            //     orgId: data.orgId,
            //     orgAddress: data.orgAddress,
            //     posId: data.posId,
            //     employeeName: data.submissionUserFullName,
            //     posResourceTotal: data.posResourceTotal,
            //     divId: data.divId,
            //     deptId: data.deptId,
            // });

            form.setFieldsValue({
                orgId: getLabelValueObject(orgOptions, data.orgName),
                divId: getLabelValueObject(divOptions, data.divName),
                deptId: getLabelValueObject(deptOptions, data.deptName),
                posId: getLabelValueObject(posOptions, data.posName),
                employeeName: data.submissionUserFullName,
                posResourceTotal: data.posResourceTotal,
                orgAddress: data.orgAddress,
            });

            // ✅ Set atom state
            setDataField(prev => ({
                ...prev,
                wbsId: id,
                orgId: data.orgId,
                orgAddress: data.orgAddress,
                posId: data.posId,
                posResourceTotal: data.posResourceTotal,
                divId: data.divId,
                deptId: data.deptId,
                employeeName: data.submissionUserFullName,
            }));

            console.log("✅ initialTaskList:", data.wbsContentList);

            setWbsTaskList(data.wbsContentList.map((item, index) => ({
                ...item,
                id: item.wbsContentId,
                taskDescription: item.wbsContentTask ?? "",
                remark: item.wbsContentRemark ?? "",
                contentId: item.wbsContentId,
                contentNo: item.wbsContentNo,
                wbsId: data.wbsId,
                outputUnit: item.wbsContentOutputUnitParamId ?? "",
                timeToComplete: Number(item.wbsContentCompletionTime ?? 0),
                outputTimeToCompleteUnit: item.wbsTuId ?? "",
                frequency: item.wbsContentFrequencyTypeParamId ?? "",
                outputCount: Number(item.wbsContentWorkResult ?? 0),
                fte: Number(item.wbsContentFte ?? 0),
                wbsCatId: item.wbsCatId ?? null,
                personnel: Number(item.wbsContentFte ?? 0), // sesuai logika hitunganmu
                isNew: false
            })));
        } else {
            errorToast('Gagal mengambil data WBS');
        }
    };


    const buildReviewPayload = () => {
        const values = form.getFieldsValue();
        return {
            taskId: dataField?.taskId || taskId,
            wbsContentList: wbsTaskList.map(item => ({
                wbsContentId: item.contentId || item.id,
                wbsContentRemark: item.remark || ""
            }))
        };
    };




    const doSave = async () => {
        const payload = buildReviewPayload();

        loadingToastId(Constant.message.savingData, payload);
        const response = await saveReviewDraft(payload);
        dismissToast(payload);

        if (response?.detail === 'OK' && response?.status === 200) {
            successToast(Constant.message.approveDataSuccess);
            navigate(APP_ROUTE_PREFIX + '/' + RouteConstant.task.index, { replace: true });
        } else {
            errorToast(Constant.message.fail);
        }
    };

    const doSubmit = async () => {
        const payload = buildReviewPayload();

        loadingToastId(Constant.message.savingData, payload);
        const response = await submitReviewDraft(payload);
        dismissToast(payload);

        if (response?.detail === 'OK' && response?.status === 200) {
            successToast(Constant.message.approveDataSuccess);
            navigate(APP_ROUTE_PREFIX + '/' + RouteConstant.task.index, { replace: true });
        } else {
            errorToast(Constant.message.fail);
        }
    };


    const handleFormSaveAsDraft = (e) => {
        e.preventDefault();
        CustomAlert.confirm({
            title: 'Save as Draft WBS Review!',
            description: 'Are you sure you want to review draft this WBS?',
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            type: 'primary',
            onConfirmButton: () => doSave()
        });
    };


    const handleFormSubmit = (e) => {
        e.preventDefault();
        CustomAlert.confirm({
            title: 'Submit  WBS Review!',
            description: 'Are you sure you want to review this WBS?',
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            type: 'primary',
            onConfirmButton: () => doSubmit()
        });
    };


    // Org dropdown
    const [orgOptions, setOrgOptions] = useState([])
    const fetchDataOrg = async () => {
        const payload = {
            pageNumber: 1,
            pageSize: 0,
            orderBy: "orgId",
            isAscending: true,
            filter: {
                orgId: null,
                orgName: "",
                status: "true",
            },
        }

        const res = await getOrgList(payload)
        if (res?.detail === 'OK' && res?.status === 200) {
            const mappedOptions = res?.data?.content.map(item => ({
                label: item?.orgName,
                value: item?.orgId
            }));
            setOrgOptions(mappedOptions);
            return mappedOptions; // ⬅️ penting agar bisa di-then
        } else {
            setOrgOptions([]);
            return []; // ⬅️ return fallback
        }
    }

    const [divOptions, setDivOptions] = useState([])
    const fetchDataDivision = async (orgId) => {
        const payload = {
            pageNumber: 1,
            pageSize: 0,
            filter: {
                divCode: "",
                divName: "",
                orgId: orgId,
                divId: null,
                status: "true",
            },
            orderBy: "divCode",
            isAscending: true
        }

        const res = await getDivisionList(payload)
        if (res?.detail === 'OK' && res?.status === 200) {
            const options = res?.data?.content.map(item => ({
                value: item?.divId,
                label: item?.divName
            }));
            setDivOptions(options);
            return options;
        } else {
            setDivOptions([]);
            return [];
        }
    }

    const [deptOptions, setDeptOptions] = useState([])
    const fetchDataDepartment = async (divId) => {
        const payload = {
            pageNumber: 1,
            pageSize: 0,
            filter: {
                divId: divId,
                deptName: "",
                status: "true",
            },
            orderBy: "deptName",
            isAscending: true
        }

        const res = await getDepartmentList(payload)
        if (res?.detail === 'OK' && res?.status === 200) {
            setDeptOptions(res.data?.content.map(item => ({
                label: item.deptName,
                value: item.deptId
            })))
        } else {
            setDeptOptions([])
        }
    }

    const [positionOptions, setPositionOptions] = useState([])
    const fetchDataPosition = async (deptId) => {
        const payload = {
            pageNumber: 1,
            pageSize: 0,
            filter: {
                deptId: deptId,
                posName: "",
                status: "true"
            },
            orderBy: "posName",
            isAscending: true
        }

        const res = await getPositionList(payload)
        if (res?.detail === 'OK' && res?.status === 200) {

            setPositionOptions(res.data?.content.map(item => ({
                label: item.posName,
                value: item.posId,
                submissionUserFullName: item.submissionUserFullName,
                posResourceTotal: item.posResourceTotal
            })))
        } else {
            setPositionOptions([])
        }
    }

    useEffect(() => {

        fetchDataOrg().then(() => {
            fetchCheckPrivilege();
            if (isEditMode) {
                fetchGetWbsById(taskId);
            }
        });

        return () => {
            setDataField(INIT_WBS);
        };
    }, [taskId]);


    return (
        <div>
            <Card>
                {/* <Form form={form} layout="horizontal" labelCol={{ span: 2 }} wrapperCol={{ span: 16 }} labelAlign="left">
                 */}
                <Form form={form} layout="horizontal" labelAlign="left">
                    <Row gutter={[16]}>
                        <Col xs={24} sm={24} md={12}>
                            <CustomFormItemSelectDropdown
                                nameFormItem="orgId"
                                label="Organization"
                                showSearch={true}
                                // value={dataField?.orgId}
                                rules={[{ required: true, message: 'Please select Organization' }]}
                                placeholder="Select Organization"
                                loading={isLoadingOrgList}
                                options={orgOptions}
                                labelCol={{ span: 8 }}
                                wrapperCol={{ span: 16 }}
                                disabled={true}
                                onChange={(value) => {
                                    setDataField(prev => ({
                                        ...prev,
                                        orgId: value,
                                        divId: null,
                                    }));

                                    //form.setFieldsValue({ divNameOption: undefined }); // clear division di form
                                    form.setFieldsValue({ divId: undefined });

                                    if (value) {
                                        fetchDataDivision(value);
                                    } else {
                                        setDivOptions([]);
                                    }
                                }}
                            />
                        </Col>

                        <Col xs={24} sm={24} md={12}>
                            <CustomFormItemText
                                nameFormItem="employeeName"
                                label="Nama Lengkap"
                                placeholder='Silahkan Pilih posisi'
                                rules={[
                                    {
                                        required: true,
                                    },
                                ]}
                                disabled={true}
                                value={dataField?.orgName}
                                labelCol={{ span: 8 }}
                                wrapperCol={{ span: 16 }}
                                onChange={(e) => {
                                    setDataField(prev => ({
                                        ...prev,
                                        orgName: e.target.value
                                    }))
                                }}
                            />
                        </Col>

                        <Col xs={24} sm={24} md={12}>
                            <CustomFormItemSelectDropdown
                                nameFormItem="divId"
                                label="Division/Unit Kerja"
                                showSearch={true}
                                rules={[{ required: true }]}
                                placeholder="Select Division"
                                loading={isLoadingDivList}
                                options={divOptions}
                                labelCol={{ span: 8 }}
                                disabled={true}
                                wrapperCol={{ span: 16 }}
                                onChange={(value) => {
                                    setDataField((prev) => ({
                                        ...prev,
                                        divId: value || null,
                                        deptId: null,
                                    }));

                                    form.setFieldsValue({ deptId: undefined }); // perbaiki key yang direset
                                    if (value) {
                                        fetchDataDepartment(value);
                                    } else {
                                        setDeptOptions([]);
                                    }
                                }}
                            />
                        </Col>

                        <Col xs={24} sm={24} md={12}>
                            <CustomFormItemInteger
                                nameFormItem="posResourceTotal"
                                label="Jumlah SDM Saat Ini"
                                required={true}
                                rules={[{ required: true, message: 'Fill in Jumlah SDM Saat Ini' }]}
                                disabled={true}
                                min={1}
                                max={1000}
                                placeholder="Enter Is (1 - 1000)"
                                alignView="right" // 
                                value={dataField?.posResourceTotal}
                                labelCol={{ span: 8 }}
                                wrapperCol={{ span: 16 }}
                                onChange={(value) => {
                                    setDataField(prev => ({
                                        ...prev,
                                        posResourceTotal: value
                                    }))
                                }}
                            />
                        </Col>
                    </Row>

                    <Row gutter={[16]}>
                        <Col xs={24} sm={24} md={12}>
                            <CustomFormItemSelectDropdown
                                nameFormItem="deptId"
                                label="Department"
                                showSearch={true}
                                value={dataField?.deptId}
                                rules={[{ required: true }]}
                                placeholder="Select Department"
                                loading={isLoadingDeptList}
                                // disabled={!dataField?.divId}
                                disabled={true}
                                options={deptOptions}
                                labelCol={{ span: 8 }}
                                wrapperCol={{ span: 16 }}
                                onChange={(value) => {
                                    setDataField((prev) => ({
                                        ...prev,
                                        deptId: value || null,
                                        positionId: null, // reset position saat dept berubah
                                    }));

                                    form.setFieldsValue({ positionNameOption: undefined }); // reset form field

                                    if (value) {
                                        fetchDataPosition(value); // chaining
                                    } else {
                                        setPositionOptions([]);
                                    }
                                }}

                            />
                        </Col>

                        <Col xs={24} sm={24} md={12}>
                            <CustomFormItemTextArea
                                nameFormItem="orgAddress"
                                label="Lokasi Kantor"
                                required={true}
                                value={dataField?.orgAddress}
                                labelCol={{ span: 8 }}
                                wrapperCol={{ span: 12 }}
                                onChange={(e) => setDataField(prev => ({ ...prev, orgAddress: e.target.value }))}
                                placeholder="Fill in Office Location"
                                disabled={true}
                            />
                        </Col>
                    </Row>

                    <Row gutter={[16]}>
                        <Col xs={24} sm={24} md={12}>
                            <CustomFormItemSelectDropdown
                                nameFormItem="posId"
                                label="Position/Jabatan"
                                showSearch={true}
                                value={dataField?.posId}
                                rules={[{ required: true }]}
                                placeholder="Select Position"
                                loading={isLoadingPosList}
                                // disabled={!dataField?.deptId}
                                disabled={true}
                                options={positionOptions}
                                labelCol={{ span: 8 }}
                                wrapperCol={{ span: 16 }}

                                onChange={(value) => {
                                    const selected = positionOptions.find(opt => opt.value === value);
                                    setDataField(prev => ({
                                        ...prev,
                                        posId: value || null,
                                        employeeName: selected?.submissionUserFullName || "", // <-- update employee name
                                        posResourceTotal: selected?.posResourceTotal || ""
                                    }))

                                    form.setFieldsValue({
                                        employeeName: selected?.submissionUserFullName || "",
                                        posResourceTotal: selected?.posResourceTotal || ""
                                    });
                                }}
                            />
                        </Col>
                    </Row>
                    <Col xs={24}>
                        <div style={{ height: 50 }} />
                    </Col>

                    <Row gutter={[16]}>
                        <Col span={24}>
                            <SectionWbsTaskReview
                                taskId={taskId}
                                isView={false}
                                form={form}
                                onChangeTaskList={(newList) => setWbsTaskList(newList)}
                                initialTaskList={wbsTaskList} // ✅ PASTIKAN INI BUKAN KOSONG
                            />

                            {/* <div style={{ textAlign: 'right', fontWeight: 'bold', marginTop: '10px' }}>
                                Total FTE: {formatterAmountFiveDigit(wbsTaskList.reduce((acc, curr) => acc + (curr.fte || 0), 0))}
                            </div> */}

                            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 10 }}>
                                <div style={{ minWidth: 150, textAlign: 'right', fontWeight: 'bold', paddingRight: 12 }}>
                                    Total FTE: {formatterAmountFiveDigit(wbsTaskList.reduce((acc, curr) => acc + (curr.fte || 0), 0))}
                                </div>
                            </div>


                        </Col>
                    </Row>
                    {/* <Row style={{ marginTop: '16px' }}>
                        <Col span={24}>
                            <Form.Item name="approvalNote" label="Catatan">
                                <Input.TextArea placeholder="Tambahkan catatan jika perlu" rows={3} />
                            </Form.Item>
                        </Col>
                    </Row> */}


                    <div style={{ display: "flex", gap: "10px", margin: "10px 0" }}>
                        <ButtonBack onClick={() => navigate(APP_ROUTE_PREFIX + "/" + RouteConstant.task.index)} disabled={isLoadingGetById || isLoadingWbs} />
                        <ButtonReview buttonText="Save as Draft"
                            onClick={handleFormSaveAsDraft}
                            loading={isLoadingWbs}
                            disabled={isLoadingGetById || isLoadingWbs}
                        />

                        <ButtonSubmit
                            onClick={handleFormSubmit}
                            loading={isLoadingWbs}
                            disabled={isLoadingGetById || isLoadingWbs}
                        />
                        {/* <ButtonRevise
                            onClick={handleFormRevise}
                            loading={isLoadingWbs}
                            disabled={isLoadingGetById || isLoadingWbs}
                        /> */}

                        {/* <ButtonReject
                            onClick={handleFormReject}
                            loading={isLoadingWbs}
                            disabled={isLoadingGetById || isLoadingWbs}
                        /> */}
                    </div>
                </Form>
            </Card>
        </div>
    )

}
